module.exports = __webpack_public_path__ + "img/noi-program-4.55aa920e.jpg";